import { render, staticRenderFns } from "./ModelTrainingUploadTips.vue?vue&type=template&id=46cace51&scoped=true&"
import script from "./ModelTrainingUploadTips.vue?vue&type=script&lang=js&"
export * from "./ModelTrainingUploadTips.vue?vue&type=script&lang=js&"
import style0 from "./ModelTrainingUploadTips.vue?vue&type=style&index=0&id=46cace51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cace51",
  null
  
)

export default component.exports